import { render } from "./ProductsPage.vue?vue&type=template&id=4fec0208"
import script from "./ProductsPage.vue?vue&type=script&lang=js"
export * from "./ProductsPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__